import FormRender from "@/components/Form/Renderer/RenderForm";
import { changePassword } from "@/services/common/security.services";
import { loginSelector, resetIsTempPass } from "@/store/features/loginSlice";
import { ChangePasswordConfig } from "@/utils/constant/formConfig.constant";
import { toastMessage } from "@/utils/helper/myToast";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

interface ChangePasswordProps {
  onClose: (props?: any) => void;
}

const ChangePassword: React.FC<ChangePasswordProps> = ({ onClose }) => {
  const { currentUser } = useSelector(loginSelector);
  const dispatch = useDispatch();

  const handleFormSubmit = async (data: any) => {
    const { confirmPassword, ...payload } = data;
    const res: any = await changePassword(payload);

    if (res?.status === 200) {
      const { message, isError } = res.data;
      if (currentUser?.isTempPass) {
        dispatch(resetIsTempPass());
      }
      onClose({ disabledWarning: true });
      return toastMessage(message, isError);
    } else {
      console.log("Error", res);
      const { message, isError } = res?.response?.data || {};
      if (message) {
        return toastMessage(message, isError);
      }
      if (res.message) {
        return toastMessage(res.message, true);
      }
    }
  };

  return (
    <FormRender
      useFormConfig={{ mode: "onSubmit", reValidateMode: "onChange", criteriaMode: "all" }}
      handleFormSubmit={handleFormSubmit}
      handleCancel={onClose}
      formConfig={ChangePasswordConfig}
      className="p-4"
      formClassName=""
    />
  );
};

export default ChangePassword;
